module.exports = __webpack_public_path__ + "static/media/rates.3800937f.png";